import { AutogenModelTopmatchProfileDetails, AutogenRowTopmatchProfileDetails } from "./autogen/AutogenModelTopmatchProfileDetails";

export class ModelTopmatchProfileDetails extends AutogenModelTopmatchProfileDetails<RowTopmatchProfileDetails> {
    constructor() {
        super(RowTopmatchProfileDetails);
    }
}

export class RowTopmatchProfileDetails extends AutogenRowTopmatchProfileDetails {
}